import React, { ReactNode, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectProfile } from '../store/profileSlice';

interface RouteProp {
  children: ReactNode;
  allowedRoles: string[] | undefined;
}

export function ProtectedRoute({
  children,
  allowedRoles,
}: RouteProp): JSX.Element {
  const user = useSelector(selectProfile);
  const navigate = useNavigate();

  const isAllowed = useMemo(() => {
    return user?.permissionGroups.some((role) =>
      allowedRoles?.includes(role.name)
    );
  }, [user, allowedRoles]);

  useEffect(() => {
    if (!isAllowed) {
      navigate('/profile', { replace: true });
    }
  }, [isAllowed, navigate]);

  return <>{children}</>;
}
